module.exports = __webpack_public_path__ + "img/41.babd54ae.jpg";